import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TabPosition } from '@progress/kendo-angular-layout';
import { Observable } from 'rxjs';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { Chart } from '~/models/chart/chart';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldSummary } from '~/models/modules/gridField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { StartEndDateChartResponseModel } from '~/models/modules/startEndDateChartResponseModel';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { DisposeToService } from '~/services/modules/stocks/dispose-to';
import { DisposeTransactionsService } from '~/services/modules/stocks/dispose-transactions';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { NoteComponent } from '~/shared/components/note/note.component';
import { GDataService } from '~/services/GDataService';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { SitesEnum } from '~/shared/enums/sites.enum';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';

@Component({
    selector: 'app-dispose-to-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DisposeToUpsertComponent extends MultiSiteAwareComponent implements OnInit {
  _deactivatedFormTabsForm: boolean = false
  _deactivatedFormTabsGridData: Array<any> = [];

  _kendoTabStripPosition: TabPosition = 'left';
  _active: boolean;
  _pageState: PageState;
  _editFormActive: boolean;
  _orderingTabsForm: boolean = false;
  _deactivatedFieldsForm: boolean = false;
  _form: FormGroup;
  _isEditForms: boolean = false;
  _currentUser: UserSummary;
  _isCustomfieldsFormValue: boolean = false;
  _deactivatedFieldsGridData: any[] = [];
  _page = 'disposeTo';
  _permissionScope = 'disposeTo';
  _gridFieldText: GridFieldTextSummary[];
  _model: any;
  _language = 'en';
  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _userNewDataTabs: Array<any> = [];
  _gridFieldAuth: GridFieldAuthorization[];
  _customFields: CustomFieldSummary[][] = [];
  _selectedAccountIds: any[] = [];
  _customTabs: any;
  _invalidSubmit: boolean;
  _systemFields: Array<any> = [];
  _editedSystemFields: Array<any> = [];
  _requiredFields: Array<any> = [];
  _requiredFieldNames: Array<any> = [];
  _customRequiredFields: Array<any> = [];
  _customFieldsValue: any = [];
  _customValidation: any = [];
  _selectedLabelId: number;
  _selectedTabId: number;
  _isRenameFormValue: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _isMandatory: boolean = false;
  _custominvalidForm: boolean;
  _theme: string;
  _index: number;
  _isAddTabFormValue: boolean = false;
  _canEditLocationType: boolean = true;
  _invalidForm: boolean;
  _customFieldsDictionary: { [key: string]: string } = {};
  _selectedLabelObjectCode: any;
  okCloseSubscription: any = null;
  _isDialiog: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;
  _disposeToCode = new FormControl();
  disposeToChartDetail: StartEndDateChartResponseModel;
  disposeToChart: Chart;
  _disposeHistoryGridColumns: GridFieldSummary[];
  isDisposeHistoryChartExpanded: boolean = true;
  isDisposeHistoryGridExpanded: boolean = true;
  _SIDActive: boolean = true;
  _SIDActiveForm: boolean = false;
  reactivate: boolean = false;
  reactivateItem: any;
  _popupSaveModel: any;

  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('kendo_BarcodeGen_Dispose_Number') kendoBarcodeGenDisposeNumber: ElementRef;
  @ViewChild('kendo_Input_Dispose_Description') kendoInputdisposeDescription: ElementRef;
  @ViewChild('note') note: NoteComponent;
  copyModelId: number;

  //#region Multi Site Variables

  //#endregion
  constructor(private _gridLayoutManagerService: GridLayoutManagerService,
    private _layoutManager: LayoutManagerService,
    private _sharedService: SharedService,
    private _securityService: SecurityService,
    private _dataService: GDataService,
    private _customFieldsService: CustomFieldsService,
    private _fb: FormBuilder,
    private _gridFields: GridFieldsService,
    private _layoutComponent: LayoutComponent,
    private _themeManager: ThemeManagerService,
    private _disposeToService: DisposeToService,
    private _disposeTransaction: DisposeTransactionsService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _multiSitesService: MultiSiteService) {
    super();
    this._getdata();
    this._currentUser = this._securityService.currentUser;
    this._layoutManager.applyOverly();
    this._currentUser = this._securityService.currentUser;

    //this.loadCustomFields(this._model?.id?.toString());
    //this.getSystemFieldsAndCustomFields();

    this.loadLabels();

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this._customFieldsService.getDeactivatedCustomFields('stock').subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
    });

    this.getAuth();
  }

  ngOnInit() {
    this._initForm();
    this._viewInactiveFields(true);
    this._viewInactiveFormTabs(true);

    this.getFormTabs();
    //    this.getSystemFields();
    this.getSystemFieldsAndCustomFields();
  }

  _closeForm(model?: any) {
    var closeComponent = {
      component: 'disposeTo',
      isClosed: true,
      response: model
    }
    // this._isDialiog = false;
    // this._layoutManager.removeOverlay();
    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('disposeTo');
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
    //Quraim
    this._dataService.push(closeComponent);
    this._sharedService.model = {};
  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;

    if (e === 'minimized') {
      element.el.nativeElement.classList.remove("fullWidthFormForm");
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove("fullWidthFormForm");
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add("fullWidthFormForm");
    }
  }

  _edit() {
    this._pageState = PageState.EDIT;
  }

  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }

  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    }
    else {
      this._editFormActive = true;
      this._isCustomfieldsFormValue = true;
    }
  }

  _returnAdNew() {
    this._pageState = PageState.ADD;
    if (this._deactivatedFormTabsGridData?.length == 0) {
      this._viewInactiveFormTabs(true);
    }
  }

  // _viewInactiveFields() {
  //     .getDeactivatedCustomFields('stock')
  //     
  //     .subscribe((data:Array<any>) => {
  //      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
  //     });
  //   this._deactivatedFieldsForm = true;
  // }
  _viewInactiveFields(onLoad: boolean = false) {
    this._customFieldsService.getDeactivatedCustomFields('stock', this._page).subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);

      if (!onLoad)
        this._deactivatedFieldsForm = true;
    });
  }

  private loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language).subscribe((data: GridFieldTextSummary[]) => {
      this._gridFieldText = data;
      this._initForm();
    })
  }

  getLabel(objectCode: any) {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)) {
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      }
      else {
        result = null;
      }

      return result ? result : null;
    }
  }


  private _initForm() {
    this._form = this._fb.group({
      code: [this._model ? this._model.code : null, Validators.required],
      description: [this._model ? this._model.description : null, this.getLabel('LBL_DisposeToDesc')?.isRequired ? Validators.required : null],
    });
  }

  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;

    if (this._pageState === (PageState.ADD || PageState.COPY) && this._model && this._model.id > 0) {
      this.copyModelId = this._model.id;
      this._model.id = null;
      this._model.code = null;
    }

    if (this._model && this._model.id) {
      this.LoadDisposeToChart();
    }

    if (this._model && this._model.site) {
      this._loadSitesAndInitDD(true, this._model.site);
    }
    else {
      this._loadSitesAndInitDD();
    }
  }

  async LoadDisposeToChart() {
    this._disposeToService.GetDisposeToChart(this._model.id).pipe().subscribe(async (data: any) => {
      this.disposeToChartDetail = data;
      this.disposeToChart = this.disposeToChartDetail.chart;
    });

    this._gridFields.getGridFieldsByPage('disposeHistory').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('disposeHistory', data);
      this._disposeHistoryGridColumns = data;
    });
  }

  _getDisposeHistoriesByDispostTo = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.disposeToChartDetail.startDate,
      endDate: this.disposeToChartDetail.endDate
    }

    return this._disposeTransaction.GetDisposeHistoriesByDisposeTo(this._model.id, startEndDate);
  }

  DisposeHistoryOnOpen(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV') {
      this._SIDActiveForm = true;
    }
  }

  DisposeHistoryOnClose() {
    this._SIDActiveForm = false;
  }

  ExpandCollapseDisposeHistoryGrid(isExpand: boolean) {
    this.isDisposeHistoryGridExpanded = !isExpand;
  }

  ExpandCollapseDisposeHistoryChart(isExpand: boolean) {
    this.isDisposeHistoryChartExpanded = !isExpand;
  }

  CheckIfWeAreInEditMode() {
    var isEditMode: boolean = false;

    if (this._pageState == PageState.EDIT) {
      isEditMode = true;
    }

    return isEditMode;
  }

  _onTabSelect(e: any) {
    this._mobileMenuToggle();
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.navTrigger?.nativeElement?.querySelector('ul');
    mobiletabstrip.classList.toggle('visibletab');
  }

  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }

  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs).subscribe((x: any) => {
      this._dataTabs = x.filter((x: any) => x.name != 'Dispose To');
      this._dataTabsSelected = x.filter((x: any) => x.name != 'Dispose To');
      this._closeOrderingTabsForm();
    })
  }

  getFormTabs() {
    this._gridFields.getformTabsByPage(this._page).subscribe((x: any) => {
      this._dataTabs = x.filter((x: any) => x.name != 'Dispose To');
      this._dataTabsSelected = x.filter((x: any) => x.name != 'Dispose To');
      this._userNewDataTabs = x.filter((x: any) => x.name != 'Dispose To');
      //this.sortProduct(p => p.order, "ASC");
    });
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      else
        result = null

      return result ? result : new GridFieldAuthorization();
    }
  }

  getSystemFields() {
    this._gridFields.getSystemFieldsByPage(this._page).subscribe((x: any) => {
      this._systemFields = x;
      this._editedSystemFields = x;
    });
  }

  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page).subscribe((x: any) => {
      this._systemFields = x;
      this._editedSystemFields = x;
      this.loadCustomFields(this._model?.id?.toString());
      //this.setMandatoryFields();
    })
  }

  // _deactivateTab(tabId: number, page: string) {
  //   let model: any = {
  //     customFieldEntityId: page == "locationTypes" ? 1 : 2,
  //     page: this._page,
  //     accountIds: this._selectedAccountIds,
  //   };
  //     if (response != null && response["message"] != null) {
  //       this.getFormTabs();
  //       //   .getFormTabsByPage(this._page)
  //       //   
  //       //   .subscribe((data: any) => {
  //       //     //get custom tabs first
  //       //     this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
  //       //   });
  //       this._layoutComponent.openPopup({
  //         title: 'Alert',
  //         message: response["message"],
  //         withoutConfirm: true
  //       });

  //       if (response["close"] != null) {
  //         if (response["close"] == true) {
  //           // this._closeForm();
  //         }
  //         else {
  //           return;
  //         }
  //       }
  //     }
  //     //   this._closeForm();
  //   });
  // }

  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    // Object.keys(customFieldsValue).forEach(key => {
    //   if (customFieldsValue[key] == null || customFieldsValue[key] == "null") {
    //     customFieldsValue[key] = "";
    //   }
    //   if (this._customFields[tabId].find(x => x.name == key).entityId == undefined) {//new mode, custom field data not added yet
    //     this._customFields[tabId].find(x => x.name == key).entityId = -1;
    //     this._customFields[tabId].find(x => x.name == key).customFieldsData.push({ id: -1, value: "null", entityId: -1 ,customFieldId:-1});
    //   }
    //   var customFieldData = this._customFields[tabId].find(x => x.name == key).customFieldsData.find(x => x.entityId == this._customFields[tabId].find(x => x.name == key).entityId);
    //   if (customFieldData != undefined) {
    //     customFieldData.value = customFieldsValue[key];
    //   }
    //   var requiredCustomerField = this._customValidation.find(
    //     (x: any) => x.name == key
    //   );
    //   if (requiredCustomerField) {
    //     let item2 = null;
    //     this._customValidation.forEach((element: any) => {
    //       if (element.name == key) {
    //         item2 = element;
    //       }
    //     });
    //     if (item2 != null) {
    //       let index2 = this._customValidation.indexOf(item2);
    //       if (index2 != -1) {
    //         //this._customValidation.splice(index2, 1);
    //         this._customValidation[index2].value = customFieldData.value;
    //       }
    //       //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
    //     }
    //   }
    // });

    // this._customFieldsValue = customFieldsValue;
    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };

      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });

      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);

        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }

      var requiredCustomerField = this._customValidation.find((x: any) => x.name == key);

      if (requiredCustomerField) {
        let item2 = null;

        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });

        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);

          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }

      this._additionalErrors = [];

      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }

      this._customFieldsValue.push(customObject);
    });
  }

  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex(x => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter(x => x.id != customFieldId);
          this.setMandatoryFields();
          this._viewInactiveFields(true);
          return;
        }
      }
    }
  }
  _viewInactiveFormTabs(onLoad: boolean = false) {
    this._customFieldsService
      .getDeactivatedCustomForms(this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFormTabsGridData = data;
        //  if(!onLoad)
        //  this._deactivatedFormTabsForm = true;
      });
  }
  reactivateTab: boolean;
  _reactivateFormTab(item: any) {
    this.reactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      this.reactivateTab = true;
      if (boolData && this.reactivateTab) {
        // if (boolData && this.reactivateTab && (this.lastTabIdReactivated.length == 0 || !this.lastTabIdReactivated.includes(item.id))) {
        this.reactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService
          .reactivateFormTab(item.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              // if (this.lastTabIdDeactivated.includes(item.id)) {
              //   this.lastTabIdDeactivated = this.lastTabIdDeactivated.filter(id => id !== item.id);
              // }
              // this.lastTabIdReactivated.push(item.id);
              this._viewInactiveFormTabs(false)
              this._customFieldsService
                .getFormTabsByPage(this._page)

                .subscribe((data: any) => {
                  //get custom tabs first
                  this.getFormTabs();
                  this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
                });
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                } else {
                  return;
                }
              }
            }
          });
      } else {
        this.reactivateTab = false;
      }
      sub.unsubscribe();
    });


    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }
  _closeInactiveFormTabs() {
    this._deactivatedFormTabsForm = false;
  }
  // lastTabIdDeactivated:number[] = []
  // lastTabIdReactivated:number[] = []
  //#endregion
  deactivateTab: boolean
  _deactivateTab(tabId: number, page: string) {
    this.deactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      if (boolData && this.deactivateTab) {
        // if (boolData && this.deactivateTab && (this.lastTabIdDeactivated.length == 0 || !this.lastTabIdDeactivated.includes(tabId))) {
        this.deactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService.deleteCustomTab(tabId, model).subscribe((response: any) => {
          // this.lastTabIdDeactivated.push(tabId);
          // if (this.lastTabIdReactivated.includes(tabId)) {
          //   this.lastTabIdReactivated = this.lastTabIdReactivated.filter(id => id !== tabId);
          // }

          if (response != null && response['message'] != null) {
            this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
              //get custom tabs first
              this.getFormTabs();
              this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
            });

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                // this._closeForm();
              }
              else {
                return;
              }
            }
          }
        });
      } else {
        this.deactivateTab = true;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Deactivate This Tab?',
    });

  }


  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }

  _addNewField(tabId: number) {
    this._selectedTabId = null
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }

  _reorderingtabs() {
    this._orderingTabsForm = true;
  }

  _onCancel() {
    this._closeForm(this._popupSaveModel);
  }

  _onSave(e: any) {
    this.submit(e);
  }

  _additionalErrors: any = [];

  private submit = (e: string) => {
    //if (this._form.invalid && this._custominvalidForm) {
    if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidForm = true;
      this._invalidSubmit = true;
    }
    else if (this._form.invalid) {
      this._invalidForm = true;
      //} else if(this._custominvalidForm){
    }
    //else if(this._customValidation.length > 0){
    else if (this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidSubmit = true;
      this._invalidForm = true;
    } else {
      // work with custom fields
      // if (this._customFieldsValue) {
      //   const entries = Object.entries(this._customFieldsValue);
      //   for (const [index, [key, value]] of entries.entries()) {
      //     this._customFieldsDictionary[key] = `${value}`;
      //   }
      // }
      // //
      // this._invalidForm = false;
      // this._invalidSubmit = false;
      this._invalidForm = false;
      this._invalidSubmit = false;

      if (this._customFieldsValue) {
        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });
      }

      const model = this._form.value;
      model['customFieldsValue'] = this._customFieldsDictionary;
      model["siteId"] = this._siteSelected?.id;
      if (!this._model || !this._model.id) {
        //  if (this._pageState == PageState.ADD) {
        this._disposeToService.createDisposeToLocation(model).subscribe((response: any) => {
          if (response != null && response['message'] != null) {
            // this.note.createNote(response.responseId);
            const addedModel = response.extraData ? response.extraData : { ...model, id: response.responseId };
            this._disposeToService.disposeToAdded.emit(addedModel);
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                //this._closeForm();
                if (e === "saveAndClose") {
                  this._popupSaveModel = { ...response.extraData };
                  this._closeForm(this._popupSaveModel);
                }
                else if (e === "saveAndCopy") {
                  this._popupSaveModel = { ...response.extraData };
                  this.copyModelId = this._model.id;
                  this._model.id = undefined;
                  this._pageState = PageState.ADD;
                  this._form.controls.code.setValue(null);
                }
                else if (e === "saveAndNew") {
                  this._popupSaveModel = { ...response.extraData };
                  this._initForm();
                  this.openUpsert(this._page, {}, PageState.ADD);
                  //this._closeForm();
                }
                else if (e === 'save') {
                  this._popupSaveModel = { ...response.extraData };
                  this._pageState = PageState.EDIT;
                  this._model.id = response.responseId;
                  this.LoadDisposeToChart();
                }
              }
              else {
                return;
              }
            }
          }
          //this._closeForm();
        });
      }
      else {
        this._disposeToService.updateDisposeToLocation(this._model.id, model).subscribe((response: any) => {
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                //this._closeForm();
                if (e === "saveAndClose") {
                  this._closeForm();
                }
                else if (e === "saveAndCopy") {
                  this._popupSaveModel = { ...model };
                  this.copyModelId = this._model.id;
                  this._model.id = undefined;
                  this._pageState = PageState.ADD;
                  this._form.controls.code.setValue(null);
                  this.loadCustomFields();
                }
                else if (e === "saveAndNew") {
                  this.openUpsert(this._page, {}, PageState.ADD);
                  //this._closeForm();
                }
                else if (e === 'save') {
                  this._popupSaveModel = { ...model };
                }
              }
              else {
                return;
              }
            }
          }
          //this._closeForm();
        });
      }
    }
  }

  requiredSystemTabs: any = [];

  setMandatoryFields() {
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    this._customValidation = [];

    setTimeout(() => {
      for (let item of this._systemFields) {
        if (item.gridFieldText.isRequired) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired) {
              this._requiredFields.push(item3);
            }
          }
        }
      }

      this._requiredFields.forEach((element) => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });

      let tabElementList = this.navTrigger?.nativeElement?.querySelector('ul');
      if (tabElementList) {
        Array.from(tabElementList?.children)?.forEach((child: any) => {
          child.classList.remove('mendatoryTab');
        });

        Array.from(tabElementList?.children)?.forEach((child: any) => {
          if (this._requiredFieldNames.find((x) => x.name.trim() === child.firstChild.innerText.trim())) {
            child.classList.add('mendatoryTab');
          }

          if (this.requiredSystemTabs.find((x: any) => x.name.trim() === child.firstChild.innerText)) {
            child.classList.add('mendatoryTab');
          }
        });
      }

      this._requiredFields.forEach((element) => {
        if (element.customFieldType) {
          this._customRequiredFields.push(element);
          let thisvalue =
            element.customFieldsData.filter((x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)).length > 0
              ? element.customFieldsData.filter((x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId))[0].value
              : '';

          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });
    }, 500);
  }

  private loadCustomFields(entityId?: string) {
    entityId = this.copyModelId?.toString() ?? this._model?.id?.toString();
    this._customFieldsService.getCustomFields('stock', this._page, entityId).subscribe((data) => {
      if (this._model != null && this._model.id != null || this.copyModelId != null) {
        let that = this;
        data.map(function (x) {
          x.entityId = that._model.id ?? that.copyModelId;
        });
      }

      var tabIds = data.map(item => item.formTabId).filter((value, index, self) => self.indexOf(value) === index);

      const grouped = this.groupBy(data, (item: { formTabId: any; }) => item.formTabId);
      let that = this;
      tabIds.forEach(function (formTabId) {
        that._customFields[formTabId] = grouped.get(formTabId);
      });

      if (this.copyModelId) {
        let CustomFieldsDataForCopy: any = {};

        grouped.forEach(element => {
          element.forEach((value: any) => {

            let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
            CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;

            if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name]) {
              CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
            }

            if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name]) {
              CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            }
          });

          this._customFieldsValueChanges(CustomFieldsDataForCopy, null);
        });
      }

      this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
        //get custom tabs first
        this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
        this.setMandatoryFields();
      });
    });
  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();

    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);

      if (!collection) {
        map.set(key, [item]);
      }
      else {
        collection.push(item);
      }
    });

    return map;
  }

  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }

  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }

  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find(x => x.order == i + 1)) {
      this._userNewDataTabs.find(x => x === this._dataTabsSelected.find(x => x.order == i + 1)).order =
        this._dataTabsSelected.find(x => x.name === e.name).order;
    }

    this._userNewDataTabs.find(obj => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter(obj => obj !== e);
  }

  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }


  _reactivate(item: any) {

    this.reactivateItem = item;
    this.reactivate = true;
    const sub = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item).subscribe((response: any) => {
          if (response != null && response["message"] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response["message"],
              withoutConfirm: true
            });

            if (response["close"] != null) {
              if (response["close"] == true) {
                //this.loadCustomFields(this._model?.id?.toString());
                this.getSystemFieldsAndCustomFields();
                this.getFormTabs();
                this._viewInactiveFields(true);
                // this._deactivatedFieldsForm = false;
              }
              else {
                return;
              }
            }
          }
          // this._deactivatedFieldsForm = false;
        });
        // this._deactivatedFieldsForm = false;
      }
      else {
        this.reactivate = false;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }

  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState }
  }

  _closeDialog(event: boolean) {
    this._isDialiog = event;
  }

  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }

  private runGenerateBarcode() {
    let counter = 1;

    this.generateBarcode(counter).subscribe((data: any) => {
      this._disposeToCode.setValue(data.result.toString());
      this._form.patchValue({ code: data.result.toString() });
    });

    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoInputdisposeDescription.nativeElement.focus();
        let CategoryDesc = this.kendoInputdisposeDescription;
        CategoryDesc.nativeElement.classList.add('focusedInput');
      });
    }
  }

  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService.getBarcode('locations', quantity);
  }

  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }

  _hasCustomTabs() {
    return this._dataTabs.find((x: any) => x.isCustom);
  }

  _loadSitesAndInitDD(IsEdit: boolean = false, SavedSite: any = null) {
    this._multiSitesService.getAllSites().subscribe((data: any) => {
      this._sites = data || [];
      this._sitesFiltered = this._sites;

      this.initAllSitesDropDown(IsEdit, SavedSite);
    });
  }

  initAllSitesDropDown(isEdit: boolean = false, SavedSite: any = null) {
    super.initAllSitesDropDown(isEdit, SavedSite);
  }
  //#endregion
}
